export default __webpack_public_path__ + "static/media/3031 spice rack C top.7e643307.png";